import { call, put, takeEvery, all } from 'redux-saga/effects';
import {
  GET_SAVED_REPORTS,
  SAVE_REPORT,
  DELETE_SAVED_REPORT,
} from './actionType';
import {
  getSavedReports as getSavedReportsAction,
  getSavedReportsSuccess,
  getSavedReportsFailure,
  saveReportSuccess,
  saveReportFailure,
  deleteSavedReportSuccess,
  deleteSavedReportFailure,
} from './action';
import {
  getSavedReportsApi,
  createSavedReportApi,
  deleteSavedReportApi,
} from '../../helpers/fakebackend_helper';

function* getSavedReports() {
  try {
    const response = yield call(getSavedReportsApi);
    yield put(getSavedReportsSuccess(response));
  } catch (error) {
    yield put(getSavedReportsFailure(error));
  }
}

function* saveReport({ payload }) {
  try {
    const response = yield call(createSavedReportApi, [payload]);
    yield put(saveReportSuccess(response));
    yield put(getSavedReportsAction());
  } catch (error) {
    yield put(saveReportFailure(error));
  }
}

function* deleteSavedReport({ payload }) {
  try {
    const response = yield call(deleteSavedReportApi, [payload]);
    yield put(deleteSavedReportSuccess(response));
    yield put(getSavedReportsAction());
  } catch (error) {
    yield put(deleteSavedReportFailure(error));
  }
}

function* watchGetSavedReports() {
  yield takeEvery(GET_SAVED_REPORTS, getSavedReports);
}
function* watchSaveReport() {
  yield takeEvery(SAVE_REPORT, saveReport);
}
function* watchDeleteSavedReport() {
  yield takeEvery(DELETE_SAVED_REPORT, deleteSavedReport);
}

export default function* ReportSavedSaga() {
  yield all([
    watchGetSavedReports(),
    watchSaveReport(),
    watchDeleteSavedReport(),
  ]);
}
